export default function styleConsole(backgroundColor) {
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'white';
  var styles = "background-color: ".concat(backgroundColor, "; border-radius: 4px; padding: 2px 4px;");
  if (color) {
    styles += " color: ".concat(color, ";");
  }
  return [styles, ''];
}